'use client';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number;
  className?: string;
}

export default function Skeleton({ width = '100%', height = '100%', borderRadius = 4, className = '' }: SkeletonProps) {
  const widthStyle = typeof width === 'number' ? `${width}px` : width;
  const heightStyle = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={`animate-pulse bg-skeleton  ${className}`}
      style={{
        width: widthStyle,
        height: heightStyle,
        borderRadius: `${borderRadius}px`,
      }}
    />
  );
}
